import { IError } from '../base/error'
import ServiceBase from '../base/service.base'

import {
  IReportsFileResponse,
  IReportsPaginatedResponse,
  IReportsResumeResponse,
} from './reports.types'

export class Reports extends ServiceBase {
  private mainURL = '/reports'

  public async reportsResume(): Promise<IReportsResumeResponse[]> {
    const url = `${this.mainURL}/resume`

    const response = await this.request.get<IReportsResumeResponse[], IError>(
      url,
    )

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  public async getReport(
    type: string,
    page: number,
    limit = 5,
  ): Promise<IReportsPaginatedResponse> {
    const url = `${this.mainURL}/${type}`

    const response = await this.request.get<IReportsPaginatedResponse, IError>(
      url,
      {
        params: {
          page,
          limit,
        },
      },
    )

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  public async getReportFile(type: string): Promise<IReportsFileResponse> {
    const url = `${this.mainURL}/${type}/file`

    const response = await this.request.get<IReportsFileResponse, IError>(url)

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }
}
